import { render, staticRenderFns } from "./About.vue?vue&type=template&id=d5402882&scoped=true&"
var script = {}
import style0 from "./About.vue?vue&type=style&index=0&id=d5402882&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5402882",
  null
  
)

export default component.exports